// A minimal browser-`WebSocket`-backed `Transport`/`TransportFactory` (design D7):
// the production counterpart to the scripted mock transport (`test/mock-transport.ts`)
// that every connection-machine and LOD test drives instead. Decodes inbound frames
// with `decodeServerMessage`, routing a decode failure to `onMalformed` — the D7 trust
// boundary — rather than letting a malformed frame reach `onMessage`. Exercised
// end-to-end only by the opt-in live-interop job against a running server (task 8,
// CF1); not unit-tested here (a real socket needs a real server).

import { decodeServerMessage } from './codec';
import type { Transport, TransportFactory, TransportHandlers } from './connection';

export function createWebSocketTransportFactory(url: string): TransportFactory {
  return (handlers: TransportHandlers): Transport => {
    const socket = new WebSocket(url);
    socket.binaryType = 'arraybuffer';

    socket.addEventListener('open', () => handlers.onOpen());
    socket.addEventListener('close', () => handlers.onClose());
    socket.addEventListener('message', (event: MessageEvent<ArrayBuffer>) => {
      const bytes = new Uint8Array(event.data);
      const result = decodeServerMessage(bytes);
      if (result.ok) {
        handlers.onMessage(result.value);
      } else {
        handlers.onMalformed(result.error);
      }
    });

    return {
      send(bytes: Uint8Array): void {
        socket.send(bytes);
      },
      close(): void {
        socket.close();
      },
    };
  };
}
